export default __webpack_public_path__ + "static/media/flashcard-cursor-2.1d31535a.png";